import { render, staticRenderFns } from "./subscrier.vue?vue&type=template&id=998628f2&scoped=true&"
import script from "./subscrier.vue?vue&type=script&lang=js&"
export * from "./subscrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998628f2",
  null
  
)

export default component.exports